import { Box, Button, Drawer, Tooltip, Typography } from '@mui/material'
import React, { Component } from 'react'
import { Colors } from '../../../Styles/Colors'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import './RadBillTrans.css'
import { AmountsCard } from '../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../Utility/ImagePaths'
import { DataGrid } from '@mui/x-data-grid'
import { DateTime } from 'luxon'
import { AmountFormat, CheckAccessFunc, formatDate, GetInvestigationName, timeOnlyConvert } from '../../../Components/CommonFunctions/CommonFunctions'
import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents'
import RadBillingFilter from './RadBillingFilter'
import { localGetItem, localSetItem } from '../../../Utility/Services/CacheProviderService'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'

let isUser = null;

export default class RadCancelledBills extends Component {
  constructor(props) {
    super(props)
    const savedFilter = JSON.parse(localGetItem('globalDateFilter') || 'null');
    this.state = {
      cancelledBillData: [],
      totalBill: 0,
      totalCancelAmount: 0,
      page: 0,
      pageSize: 10,
      FilterDatas: {
        "FromDate": savedFilter?.FromDate || DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        "ToDate": savedFilter?.ToDate || DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        "DateIndex": savedFilter?.DateIndex || 1,
        "PatientName": "",
        "AccNo": "",
        "MobNo": "",
        "DoctorName": [],
        "BillNumber": "",
        "PaidAmount": "",
        "InPatientSelected": true,
        "OutPatientSelected": true,
        "PaidSelected": true,
        "PartialPaidSelected": true,
        "CreditSelected": true,
        "CardSelected": true,
        "CashSelected": true,
        "UPISelected": true,
        "BankTransferSelected": true,
        "InsuranceSelected": true,
        "ChequeSelected": true,
        "BillType": ['op', 'ip', GetInvestigationName(true)],
        "PayStatus": [],
        "PayMethods": [],
        "startTime": null,
        "endTime": null,
        "BillModuleType": ['op', 'ip', GetInvestigationName(true)],
        "opCreditBills": true,
        "ipCreditBills": true,
        'radiologyCreditBills': true,
        'RadiologyBills': true,
        "RadiologySelected": true,
        'UserList': [],
        'UserDetails': [],
      },
    }
  }

  componentDidMount() {
    isUser = JSON.parse(localGetItem('loggedInUserInfo'))
    this.getCancelledBillData()
     this.GetUserDetails()
  }

  getCancelledBillData = () => {
    try {
      this.LoaderFunction(true)
      let states = this.state
      let User_ID = []
      states.FilterDatas.UserDetails.forEach(element => User_ID.push(element.id))
      let start_time = states.FilterDatas.startTime ? new Date(states.FilterDatas.startTime) : ''
      let end_time = states.FilterDatas.endTime ? new Date(states.FilterDatas.endTime) : ''
      let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
      let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

      let doctorId = [];
      states.FilterDatas.DoctorName.forEach(element => doctorId.push(element.doctor_id))
      const baseUrl = (localGetItem('isNewBilling') === "true") ? (localGetItem('is_investigation_module') === "true" ? Serviceurls.NEW_INVESTIGATION_CANCEL_BILL_TRANS_GET : Serviceurls.NEW_RAD_CANCEL_BILL_TRANS_GET) : Serviceurls.RAD_CANCEL_BILL_TRANS_GET;
      RestAPIService.getAll(baseUrl +
        "?from_date=" + this.state.FilterDatas?.FromDate +
        "&to_date=" + this.state.FilterDatas?.ToDate +
        "&start_time=" + setStartTime +
        "&end_time=" + setEndTime +
        "&user_id=" + User_ID +
        "&patient_name=" + this.state.FilterDatas?.PatientName +
        "&patient_acc_number=" + this.state.FilterDatas?.AccNo +
        "&mobile_number=" + this.state.FilterDatas?.MobNo +
        "&doctor_id=" + doctorId +
        "&bill_number=" + this.state.FilterDatas?.BillNumber
      )
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              cancelledBillData: response.data.data,
              totalBill: response.data.total_bill,
              totalCancelAmount: response.data.total_amount
            }, () => this.LoaderFunction(false))
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
          this.LoaderFunction(false)
        })
    } catch (error) {
      this.errorMessage(error.message)
      this.LoaderFunction(false)
    }
  }

  GetUserDetails = () => {
    let states = this.state
    try {
      RestAPIService.getAll(Serviceurls.DAY_END_USER_DETAIL_GET + `?show_all=true`)
        .then((response) => {
          if (response.data.status === 'success') {
            const UserList = response.data.data
            this.setState((prevState) => ({
              FilterDatas: {
                ...prevState.FilterDatas,
                UserList: UserList
              }
            }))
          }
        }).catch((error) => {
          if (error?.response?.data?.status === 'fail') {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }

        })
    } catch (error) {
      this.errorMessage(error)
    }
  }
  

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  gridToolBar = () => {
    let start_time = this.state.FilterDatas.startTime ? new Date(this.state.FilterDatas.startTime) : ''
    let end_time = this.state.FilterDatas.endTime ? new Date(this.state.FilterDatas.endTime) : ''
    let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
    let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

    let TextArray = [
      { label: "From Date", value: formatDate(this.state.FilterDatas.FromDate) },
      { label: "To Date", value: formatDate(this.state.FilterDatas.ToDate) },
    ]
    if (this.state.FilterDatas.startTime !== null && this.state.FilterDatas.endTime !== null) {
      TextArray.push(
        { label: "Start Time", value: timeOnlyConvert(setStartTime) },
        { label: "End Time", value: timeOnlyConvert(setEndTime) }
      )
    }
    return (
      <Box>
        <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
      </Box>
    )
  }

  ClosePopUp(Getapicall = false, message = "") {
    this.setState({
      FilterOpen: false,
      BillPreviewPop: false,
      CreditBillPopUp: false
    }, () => {
      if (Getapicall && message !== "") {
        this.successMessage(message)
      }
    })
  }

  renderFilter = (data) => {
    localSetItem('globalDateFilter', JSON.stringify({FromDate: data?.FromDate, ToDate: data?.ToDate, DateIndex: data?.DateIndex  }))
    this.setState({
      FilterDatas: data,
      FilterOpen: false,
    }, () => { this.getCancelledBillData() })
  }

  clearFilter = (data) => {
    this.setState({
      FilterDatas: data
    })
  }
  
  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  GetBillPrint = (id) => {
    try {
      this.setState({ disableBtn: true })
      RestAPIService.getAllPrint( ((localGetItem('isNewBilling') === "true") ? (isUser?.module_name === "Investigation" ? Serviceurls?.NEW_INVESTIGATION_BILL_POST : Serviceurls.NEW_RAD_BILL_POST) : Serviceurls.RAD_BILL_POST) + '?bill_summary_id=' + id + "&export_type=pdf").
        then((response) => {
          this.setState({ disableBtn: false })
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          this.setState({ disableBtn: false })
          this.errorMessage(error.response?.data?.message, false);
        })
    } catch (error) {
      this.errorMessage(error.message, false)
    }
}

  render() {
    this.state.cancelledBillData?.forEach((element, index) => element.sno = index + 1)
    const columns = [
      {
        field: 'invoice_date', headerName: 'Date And Time', flex: 0.12, align: 'center', headerAlign: 'center',
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_date_cacl'>{params?.row?.invoice_date ? params?.row?.invoice_date : '-'}</Box>)
      },
      {
        field: 'invoice_number', headerName: 'Bill Number', flex: 0.111,
        renderCell: (params) => {
          let BillNumber = "";
          if (params?.row?.invoice_number) { BillNumber = params?.row?.invoice_number }
          return (
            <Tooltip placement='top' title={BillNumber} arrow>
              <Box component={'div'}>{BillNumber ? '...' + BillNumber?.slice(-10) : "-"}</Box>
            </Tooltip>
          )
        }
      },
      {
        field: 'module_type', headerName: 'Module Type', flex: 0.10,
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_bill_type_cacl'>{params?.row?.module_type ? params?.row?.module_type : '-'}</Box>)
      },
      {
        field: 'patient_name', headerName: 'Patient Details', flex: 0.111,
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_pat_name_canc'>
          <Typography fontSize={'0.9vw'} fontWeight={600}>{params?.row?.patient_name ?
            params?.row?.patient_name?.length > 10 ?
              <Tooltip placement='top' title={params?.row?.patient_name + " " + params?.row?.patient_age + '/' + params?.row?.patient_gender?.toUpperCase()}>
                <div style={{ fontWeight: 600, fontSize: '0.9vw' }}>{params?.row?.patient_name?.slice(0, 10) + '...' + (params?.row?.patient_age ? params?.row?.patient_age : '-') + '/' + (params?.row?.patient_gender ? params?.row?.patient_gender?.toUpperCase() : '-')}</div>
              </Tooltip> :
              (params?.row?.patient_name + " " + (params?.row?.patient_age ? params?.row?.patient_age : '-') + '/' + (params?.row?.patient_gender ? params?.row?.patient_gender?.toUpperCase() : '-')) : '-'}</Typography>
          <Typography fontSize={'0.8vw'} color={Colors.grayShade}>{params?.row?.patient_acc_number ? params?.row?.patient_acc_number : '-'}</Typography>
        </Box>), valueGetter: (params) => {
          const name = params?.row?.patient_name || "";
          const number = params?.row?.patient_acc_number || "";
          return `${name} ${number}`;
        }
      },
      {
        field: 'doctor_name', headerName: 'Doctor Name', flex: 0.111,
        renderCell: (params) => (
          <Box component={'div'} emed_tid='rad_bill_trns_svr_name_ovr'>{params?.row?.doctor_name ?
            params?.row?.doctor_name?.length > 15 ?
              <Tooltip title={params?.row?.doctor_name} placement='top' arrow><Typography>{params?.row?.doctor_name?.slice(0, 12) + '...'}</Typography></Tooltip> :
              <Typography>{params?.row?.doctor_name}</Typography> : '-'}
          </Box>
        )
      },
      {
        field: 'service_data', headerName: 'Service Name & Type', flex: 0.111,
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_svr_name_cacl'>{params?.row?.service_data ?
          params?.row?.service_data?.length > 15 ?
            <Tooltip title={params?.row?.service_data} placement='top' arrow><Typography>{params?.row?.service_data?.slice(0, 15) + '...'}</Typography></Tooltip> :
            <Typography>{params?.row?.service_data}</Typography> : '-'}</Box>)
      },
      {
        field: 'net_amount', headerName: 'Total Bill', flex: 0.111,
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_tlt_bill_cacl'>{AmountFormat(params?.row?.net_amount ? params?.row?.net_amount : 0)}</Box>)
      },
      {
        field: 'cancel_reason', headerName: 'Reason', flex: 0.111,
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_rsn_cacl'>{params?.row?.cancel_reason ?
          params?.row?.cancel_reason?.length > 15 ?
            <Tooltip title={params?.row?.cancel_reason} placement='top' arrow><Typography>{params?.row?.cancel_reason?.slice(0, 15) + '...'}</Typography></Tooltip> :
            <Typography>{params?.row?.cancel_reason}</Typography> : '-'}</Box>)
      },
      {
        field: 'Action', headerName: 'Action', flex: 0.111, align: 'center', headerAlign: 'center',
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_act_cacl'>
          <Tooltip placement='top' title={'Print'}>
            <Button className='Common_Btn_Min_Width' emed_tid='rad_bill_trns_prt_cacl' disabled={this.state.disableBtn} onClick={()=>{ this.GetBillPrint(params?.row?.id)}}>
              <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'2vw'} width={'2vw'} />
            </Button>
          </Tooltip>
        </Box>)
      }
    ]
    return (
      <Box component={'div'} sx={{ backgroundColor: Colors.Background }}>
        <Box component={'div'} className='rad_bill_trns_container'>
          <Box component={'div'} className='rad_bill_trns_header_card'>
            <Box component={'div'} className='rad_bill_trns_cards'>
              {AmountsCard('Total Bill', this.state.totalBill, true, "white", false, null, 'rad_bill_trns_tlt_bill_cacl')}
              {AmountsCard('Total Cancelled Amount', this.state.totalCancelAmount, false, "white", false, null, 'rad_bill_trns_tlt_clc_amt_cacl')}
            </Box>
            <Box component={'div'} className='rad_bill_trns_btns'>
              <Tooltip placement='top' title={'Filter'} arrow>
                <Button className='Common_Btn_Min_Width rad_bill_btn' emed_tid='rad_bill_trns_flt_cacl'
                  onClick={() => this.setState({ FilterOpen: true })}>
                  <Box component={'img'} src={ImagePaths.Filter.default} height={'2vw'} width={'2vw'} />
                </Button>
              </Tooltip>
              {/* <Tooltip placement='top' title={'Print'} arrow>
                <Button className='Common_Btn_Min_Width rad_bill_btn' emed_tid='rad_bill_trns_prt_cacl' onClick={()=>{ this.GetBillPrint}}>
                  <Box component={'img'} src={ImagePaths.LabPrintIcon.default} height={'2vw'} width={'2vw'} />
                </Button>
              </Tooltip> */}
              {/* <Tooltip placement='top' title={'Export'} arrow>
                <Button className='Common_Btn_Min_Width rad_bill_btn' emed_tid='rad_bill_trns_exp_cacl'>
                  <Box component={'img'} src={ImagePaths.ExportIcon.default} height={'2vw'} width={'2vw'} />
                </Button>
              </Tooltip> */}
            </Box>
          </Box>
          <Box component={'div'} className='rad_bill_trns_content_card'>
            <DataGrid
              sx={{ backgroundColor: Colors.white }}
              columns={columns}
              rows={this.state.cancelledBillData}
              getRowId={(row) => row['sno']}
              page={this.state.page}
              pageSize={this.state.pageSize}
              hideFooterSelectedRowCount
              localeText={{
                toolbarColumns: "",
                toolbarDensity: "",
                toolbarExport: "",
                toolbarFilters: "",
                toolbarExportPrint: ""
              }}
              headerHeight={40}
              components={{
                Toolbar: this.gridToolBar,
                NoRowsOverlay: () => (
                  <Box className='eMed_conf_nodata'>
                    {'No Records To Be Shown'}
                  </Box>
                )
              }}
              rowsPerPageOptions={[10, 20, 30]}
              disableSelectionOnClick
              pagination
              onPageChange={(newPage) => { this.setState({ page: newPage }) }}
              onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
              loading={this.state.isLoader}
            />
          </Box>
        </Box>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        <Drawer
          anchor={'right'}
          open={this.state.FilterOpen}
          ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
        >
          <RadBillingFilter PageName={"CancelledBills"} FilterDatas={this.state.FilterDatas} CloseFilter={this.ClosePopUp.bind(this)} FilteredData={this.renderFilter.bind(this)} ClearData={this.clearFilter.bind(this)} callDocApi={true}/>
        </Drawer>
      </Box>
    )
  }
}
